// AppSkeleton's twin: the outline of content that is loading. A band of light travels across it (sunken → raised →
// back) once per 1.4 s (the design system's shimmer), rather than the outline blinking: a flashing placeholder is harder to
// ignore than the wait. Under reduced motion it rests on the sunken surface. It is hidden from assistive technology;
// the list or screen around it names the wait. Size and shape come from `className`.
import { cn } from './cn'

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        'h-(--stack-md) animate-skeleton rounded-(--radius-xs) bg-[linear-gradient(90deg,var(--color-sunken)_30%,var(--color-raised)_50%,var(--color-sunken)_70%)] bg-size-[250%_100%] motion-reduce:animate-none motion-reduce:bg-sunken motion-reduce:bg-none',
        className,
      )}
    />
  )
}
